import type { LucideIcon } from 'lucide-react';

export interface Pestana<T extends string> {
  clave: T;
  rotulo: string;

  descripcion: string;
  icono: LucideIcon;
}

export function Pestanas<T extends string>({
  pestanas,
  activa,
  alElegir,
  etiqueta,
}: {
  pestanas: ReadonlyArray<Pestana<T>>;
  activa: T;
  alElegir: (clave: T) => void;
  etiqueta: string;
}) {
  return (
    <nav
      aria-label={etiqueta}
      className="mb-4 flex gap-1 overflow-x-auto border-b border-armazon-200"
    >
      {pestanas.map(({ clave, rotulo, descripcion, icono: Icono }) => {
        const esActiva = clave === activa;

        return (
          <button
            key={clave}
            type="button"
            onClick={() => alElegir(clave)}
            aria-current={esActiva ? 'page' : undefined}
            className={[
              'flex shrink-0 items-center gap-2.5 border-b-2 px-4 py-2.5 text-left transition-colors',
              esActiva
                ? 'border-marca-600 text-marca-700'
                : 'border-transparent text-armazon-500 hover:border-armazon-200 hover:text-armazon-700',
            ].join(' ')}
          >
            <span
              className={`grid size-8 shrink-0 place-items-center rounded-lg transition-colors ${
                esActiva ? 'bg-marca-50 text-marca-600' : 'bg-armazon-100 text-armazon-400'
              }`}
            >
              <Icono className="size-4" aria-hidden />
            </span>

            <span className="min-w-0">
              <span className="block whitespace-nowrap text-sm font-semibold uppercase leading-tight">
                {rotulo}
              </span>
              <span
                className={`block whitespace-nowrap text-[10px] uppercase leading-tight tracking-wide ${
                  esActiva ? 'text-marca-600/70' : 'text-armazon-400'
                }`}
              >
                {descripcion}
              </span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
